import { useState } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../../constant/Endpoint";
import usePostHook from "../../../customHooks/usePostHook";
import { QuickSmsForm } from "../../../utils/validationSchemas";
import Button from "../../Reusable/Button";
import Card from "../../Reusable/Card";
import ComboboxInput from "../../Reusable/ComboboxInput";
import ContactCombobox from "../../Reusable/ContactComboboxInput/ContactComboBoxInput";
import MobilePreview from "../../Reusable/MobilePreview/MobilePreview";
import TextAreaInput from "../../Reusable/TextAreaInput/TextAreaInput";
import AddSmsModal from "../AddQuickSmsModal/AddQuickSmsModal";

const AddQuickSmsCard = ({ refetch }) => {
  const [isAddEmailModalOpen, setIsAddEmailModalOpen] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    control,
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      const res = await refetch();
      return {
        name: res?.data?.[0],
      };
    },
    resolver: yupResolver(QuickSmsForm),
  });
  const message = watch("content", "");
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["contacts"],
  });

  const handleCreate = async (values: any) => {
    const url = APIS.SEND_SMS;
    const formData = { ...values };
    try {
      const res = await mutateAsync({ url, formData, errors });
      if (res?.status === 200) {
        reset({
          name: getValues("name"),
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handlePlusButton = (e) => {
    e.preventDefault();
    setIsAddEmailModalOpen(true);
  };

  return (
    <div className={tw`pt-4`}>
      <div className={tw`min-h-[550px]`}>
        <Card>
          <div className={tw`flex flex-col lg:flex-row gap-4`}>
            <div className={tw`w-full lg:w-3/4`}>
              <form
                className={tw`flex flex-col gap-4`}
                onSubmit={handleSubmit(handleCreate)}
              >
                <ContactCombobox
                  url={APIS.CONTACT}
                  queryKey="contacts"
                  register={register("recipient")}
                  errors={errors.recipient}
                  name="recipient"
                  props={{ is_active: true }}
                  label={"To"}
                  setValue={setValue}
                  watch={watch}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
                <div className={tw`flex gap-4`}>
                  <div className={tw`w-full`}>
                    <ComboboxInput
                      url={APIS.SENDER_SMS}
                      queryKey="contacts"
                      register={register("name")}
                      errors={errors.name}
                      name="name"
                      props={{ is_active: true }}
                      label={"From"}
                      setValue={setValue}
                      watch={watch}
                      getValues={getValues}
                      clearErrors={clearErrors}
                    />
                  </div>
                  <div className={tw`w-[8%] relative top-8`}>
                    <div className={tw`text-[20px] leading-none text-center`}>
                      <Button
                        label="+"
                        disabled={true}
                        type="button"
                        onClick={handlePlusButton}
                      />
                    </div>
                  </div>
                </div>
                <TextAreaInput
                  label="Message"
                  placeholder="Write a message here..."
                  row={12}
                  register={register("content")}
                  errors={errors.content}
                />
                <div className={tw`flex justify-end`}>
                  <div className={tw`w-40`}>
                    <Button
                      label="Send SMS"
                      type="submit"
                      isLoading={isPostLoading}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div
              className={tw`hidden lg:flex items-center justify-center w-full lg:w-1/4`}
            >
              <div className="relative">
                <MobilePreview
                  imageUrl="https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png"
                  description="Placeholders will be replaced for all contacts in a list. This is an example of the first contact."
                  message={message}
                />
              </div>
            </div>
          </div>
        </Card>
        <AddSmsModal
          isOpen={isAddEmailModalOpen}
          setIsOpen={setIsAddEmailModalOpen}
        />
      </div>
    </div>
  );
};

export default AddQuickSmsCard;
